import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import webinarBanner from "../assets/WEBINAR-RPA-banner.jpg";

import { FaRobot, FaVideo, FaCube } from "react-icons/fa";
import { MdCases } from "react-icons/md";
import { AiOutlineRight } from "react-icons/ai";

import qaBanner from "../assets/qa_banner.png";
import qaMain from "../assets/qa3.png";

import consultingIcon from "../assets/qaconsultant.png";
import functionalIcon from "../assets/3538820-200.png";
import automationIcon from "../assets/2715089-200.png";
import performanceIcon from "../assets/1290733-200.png";
import securityIcon from "../assets/Group-680-1.png";
import mobileTestingIcon from "../assets/mobiletesting.png";
import staffIcon from "../assets/outstaff.png";
import { MdFindInPage } from "react-icons/md";
import { FiSearch } from "react-icons/fi";

/* ─── Global responsive CSS ──────────────────────────────────────────── */
const QA_CSS = `
  .qa-tabs-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
  }
  .qa-tab-item {
    background: rgba(48, 128, 120, 0.28);
    border: 1px solid rgba(0,0,0,0.10);
    min-height: 58px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    gap: 10px;
  }
  .qa-tab-label {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    font-family: "Exo", sans-serif;
    white-space: nowrap;
  }

  .qa-core-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 60px 80px;
    background: #efefef;
    gap: 50px;
  }
  .qa-core-img {
    max-width: 600px;
    width: 100%;
    object-fit: contain;
    margin-left: -40px;
    flex-shrink: 0;
  }
  .qa-core-text { max-width: 600px; width: 100%; }

  .qa-diff-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
  }
  .qa-diff-card {
    border: 2px solid rgba(255,255,255,0.9);
    border-radius: 8px;
    min-height: 120px;
    padding: 16px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .qa-services-top-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
  .qa-services-bottom-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-top: 20px;
  }
  .qa-service-card-top {
    background: #efefef;
    border: 2px solid #4b84d9;
    border-radius: 5px;
    padding: 30px 35px 20px;
  }
  .qa-service-card-bottom {
    background: #efefef;
    border: 2px solid #4b84d9;
    border-radius: 5px;
    padding: 20px 25px;
  }
  .qa-service-title {
    font-size: 25px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 22px;
  }

  .qa-casestudies-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 28px;
  }

  /* ── Small desktop / large tablet ≤ 1100px ── */
  @media (max-width: 1100px) {
    .qa-diff-grid { grid-template-columns: repeat(3, 1fr) !important; }
    .qa-services-bottom-grid { grid-template-columns: repeat(2, 1fr) !important; }
  }

  /* ── Tablet ≤ 900px ── */
  @media (max-width: 900px) {
    .qa-tabs-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .qa-core-inner { flex-direction: column !important; padding: 40px 24px !important; gap: 30px !important; }
    .qa-core-img { margin-left: 0 !important; max-width: 420px !important; }
    .qa-services-top-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .qa-services-bottom-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .qa-casestudies-grid { grid-template-columns: repeat(2, 1fr) !important; }
  }

  /* ── Mobile ≤ 600px ── */
  @media (max-width: 600px) {
    .qa-tabs-grid { grid-template-columns: 1fr !important; }
    .qa-tab-label { white-space: normal !important; font-size: 16px !important; }
    .qa-diff-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .qa-services-top-grid { grid-template-columns: 1fr !important; }
    .qa-services-bottom-grid { grid-template-columns: 1fr !important; }
    .qa-casestudies-grid { grid-template-columns: 1fr !important; }
    .qa-service-title { margin-bottom: 16px !important; }
  }

  /* ── Small mobile ≤ 420px ── */
  @media (max-width: 420px) {
    .qa-diff-grid { grid-template-columns: 1fr !important; }
  }
`;

function QAPage() {
    const location = useLocation();

useEffect(() => {
  if (location.state?.scrollTo) {
    const el = document.getElementById(location.state.scrollTo);

    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth" });
      }, 200);
    }
  }
}, [location]);
  const scrollToSection = (id) => {
    const el = document.getElementById(id);

    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const tabs = [
    {
      label: "QA Services",
      icon: <FaRobot />,
      id: "services"
    },
    {
      label: "QA Use Cases",
      icon: <FaCube />,
      id: "usecases"
    },
   {
  label: "Case Studies",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 2H7C6.45 2 6 2.45 6 3V21C6 21.55 6.45 22 7 22H17C17.55 22 18 21.55 18 21V6L14 2Z"
        stroke="white"
        strokeWidth="2"
      />
      <path d="M14 2V6H18" stroke="white" strokeWidth="2" />
      <path d="M9 10H15" stroke="white" strokeWidth="1.5" />
      <path d="M9 13H13" stroke="white" strokeWidth="1.5" />
      <circle
        cx="15.5"
        cy="14.5"
        r="3.5"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M18 17L21 20"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  id: "casestudies"
},
    {
      label: "Demo Videos",
      icon: <FaVideo />,
      id: "videos"
    }
  ];

  const differentiators = [
    ["20+", "Ready to deploy Frameworks"],
    ["Security Test cases (250+)", "Ready to use OWASP based test cases"],
    ["Mobile Test cases (120+)", "Ready to use Android & iOS test case pack"],
    ["Migration", "Migration Expertise"],
    ["Test Analytics", "ML based test analytics"],
    ["Free – PoC", "Proof of concept (MVP) @ FREE of cost"],
    ["SME’s", "We are SME’s not QA’s"],
    ["Matured Processes Reports", "Multi language/technologies test reports"]
  ];

  const services = [
    {
      title: "Consulting",
      icon: consultingIcon,
      points: [
        "Develop strategy & Road map",
        "Setting up QA Center of Excellence (CoE)",
        "Tool evaluations & Recommendations",
        "Proof of concept Development (PoC / MVP)"
      ]
    },

    {
      title: "Functional / Manual / Domain Led Testing",
      icon: functionalIcon,
      points: [
       "Domain/Business Assurance Testing ( BFSI,  Retail, E-Com, Healthcare, SAP etc., )",
"Test case design & development ",
"Test Metrics Dashboard & Defect RCA",
"AI based Test analytics"
      ]
    },

    {
      title: "Automation Testing",
      icon: automationIcon,
      points: [
        "Ready to Deploy Frameworks ( Selenium, Protractor, BDD, TDD, NightWatch.Js, TestComplete, UFT etc.,)",
"Script Development ( Open Source & Commercial) & Maintenance ",
"Continuous Integration & Continuous Delivery (DevOps)",
"Customised Reports ( Extent / Allure / Serenity / HTML )",
"Orchestration with Kubernetes / Dock"
      ]
    },

    {
      title: "Mobile Application Testing",
     icon: mobileTestingIcon,
      points: [
        "Ready to use Andriod & iOS test case pack (200+)",
"Ready to Deploy Frameworks ( Open Source & Commercial)",
"Functional, Non Functional, Multi Device / Version testing",
"Management Dashboards"
      ]
    },

    {
      title: "Performance Testing",
      icon: performanceIcon,
      points: [
        "Ready to deploy frameworks & accelerators ",
"Load / Stress / Endurance Testing",
"Performance Engineering", 
"Performance Monitoring & analytics" 
      ]
    },

    {
      title: "Security / Penetration Testing",
      icon: securityIcon,
      points: [
        "Ready to use OWASP based test cases",
        "Vulnerability Scanning",
        "Static Analysis",
        "Dynamic Analysis"
      ]
    },

    {
      title: "QA Staff outsourcing",
      icon: staffIcon,
      points: [
        "Expert testers / SDET as per the requirement",
"Short term & Long term skilled resource deployment",
      ]
    }
  ];
const topServices = services.slice(0, 3);
const bottomServices = services.slice(3);
  const caseStudies = [
    {
      title: "Mobile Application Testing",
      desc:
        "A communicator application used for the communication between team members. This is cloud based customizable application, supports web & mobile.",
      geo: "APAC (Malaysia)",
      tools: [
        "Jira – Test & Defect Management",
        "Selenium & TestNG – Automation",
        "Appium – Mobile Automation",
        "JMeter – Performance Testing",
        "BurpSuite Pro – Pen Testing"
      ]
    },

    {
      title: "Mobile Test Automation & Manual Testing",
      desc:
        "A group of mobile applications used for employee rewards & satisfaction, offline book reading, task management, feedback management etc.,",
      geo: "USA",
      tools: [
        "Enterprise Mobile Automation Framework",
        "Appium",
        "Browser Stack"
      ]
    },

    {
      title: "Test Automation – Responsive application",
      desc:
        "A web platform to support vue js development community. This platform contains tutorials, discussion forums, articles, courses etc.,",
      geo: "ANZ (Australia)",
      tools: [
        "JS Test Automation Framework",
        "Nightwatch JS",
        "Bugzilla"
      ]
    },

    {
      title: "Performance Testing & Engineering: Pen Testing",
      desc:
        "A business intelligence product providing data visualization of large sets of data by using Artificial Intelligence.",
      geo: "USA, APAC (Singapore)",
      tools: [
        "Jmeter",
        "BlazeMeter",
        "Performance Engineering Framework",
        "BurpSuite Pro"
      ]
    },

    {
      title:
        "Test Automation CoE setup, Framework and Test Automation",
      desc:
        "A group of applications used for hearing equipment which includes monitoring system, devices etc.,",
      geo: "Europe (UK)",
      tools: [
        "Testcomplete",
        "Automation framework",
        "QA Complete"
      ]
    },

    {
      title:
        "Test Automation CoE setup, Framework and Test Automation",
      desc:
        "A group of applications used for hearing equipment which includes monitoring system, devices etc.,",
      geo: "Europe (UK)",
      tools: [
        "Testcomplete",
        "Automation framework",
        "QA Complete"
      ]
    }
  ];

  return (
    <div style={{ overflowX: "hidden" }}>
      <style>{QA_CSS}</style>


      <div
        style={{
          background: "#2fb7a4"
        }}
      >
        {/* HERO */}
        <div
          style={{
            width: "100%",
            background: "#2fb7a4"
          }}
        >
          <img
            src={qaBanner}
            alt="QA Banner"
            style={{
              width: "100%",
              display: "block"
            }}
          />
        </div>

        
        {/* TOP TABS */}
<div
  style={{
    backgroundImage: `linear-gradient(rgba(43,190,174,0.78), rgba(43,190,174,0.78)), url(${webinarBanner})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    padding: "20px 18px"
  }}
>
          <div className="qa-tabs-grid">
            {tabs.map((tab, i) => (
              <div
                key={i}
                onClick={() => scrollToSection(tab.id)}
                className="qa-tab-item"
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px"
                  }}
                >
                  <div
                    style={{
                      width: "35px",
                      height: "35px",
                      background: "rgba(0,0,0,0.18)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "8px",
                      color: "#fff",
                      flexShrink: 0
                    }}
                  >
                    {React.cloneElement(tab.icon, { size: 18 })}
                  </div>

                  <span className="qa-tab-label">
                    {tab.label}
                  </span>
                </div>

                <AiOutlineRight
                  size={15}
                  style={{
                    color: "#fff",
                    flexShrink: 0
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* CORE SECTION */}
        <div className="qa-core-inner">
          <img
            src={qaMain}
            alt="QA"
            className="qa-core-img"
          />

          <div className="qa-core-text">
            <p
              style={{
                color: "#3976c9",
                fontWeight: "600",
                fontFamily: "Exo, sans-serif"
              }}
            >
              Core Services Portfolio
            </p>

            <h1
              style={{
                fontSize: "clamp(28px, 4vw, 40px)",
                fontWeight: "700",
                lineHeight: "1.1",
                fontFamily: "Exo, sans-serif",
                color: "#2B2B2B",
                marginBottom: "25px"
              }}
            >
              Software Quality Assurance
            </h1>

            <p
              style={{
                lineHeight: "1.7",
                fontSize: "15px",
                color: "#333"
              }}
            >
              With our diverse experience in Software Assurance &
              Engineering and expertise in technologies like AI,
              Machine Learning, DevOps, and Automation we ensure to
              optimize release cycles, cut across testing cycles
              leveraging shift left approaches to ensure maximum
              test coverage and quality.
            </p>
          </div>
        </div>

        {/* DIFFERENTIATORS */}
        <div
          style={{
            background: "#264785",
            padding: "22px 16px 60px",
            overflow: "hidden"
          }}
        >
          <h1
            style={{
              textAlign: "center",
              color: "#fff",
              fontSize: "clamp(26px, 4.5vw, 46px)",
              fontWeight: "700",
              marginBottom: "36px",
              fontFamily: "Exo, sans-serif",
              lineHeight: "1.15"
            }}
          >
            QA Differentiators
          </h1>

          <div className="qa-diff-grid">
            {differentiators.map((item, i) => (
              <div
                key={i}
                className="qa-diff-card"
              >
                <h2
                  style={{
                    color: "#fff",
                    fontSize: "22px",
                    fontWeight: "700",
                    marginBottom: "18px",
                    fontFamily: "Exo, sans-serif",
                    lineHeight: "1.2"
                  }}
                >
                  {item[0]}
                </h2>

                <p
                  style={{
                    color: "#1fe0c4",
                    fontSize: "13px",
                    lineHeight: "1.6",
                    fontWeight: "600",
                    fontFamily: "Exo, sans-serif",
                    margin: 0
                  }}
                >
                  {item[1]}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* SERVICES */}
        <div
          id="services"
          style={{
            background: "#efefef",
            padding: "50px 24px 70px"
          }}
        >
          <h1
            style={{
              textAlign: "center",
              fontSize: "clamp(28px, 5vw, 52px)",
              fontWeight: "700",
              marginBottom: "38px",
              fontFamily: "Exo, sans-serif",
              color: "#111",
              lineHeight: "1.15"
            }}
          >
            QA Services
          </h1>

          {/* TOP ROW - 3 CARDS */}
<div className="qa-services-top-grid">
  {topServices.map((service, i) => (
    <div
      key={i}
      className="qa-service-card-top"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "14px"
        }}
      >
        <img
          src={service.icon}
          alt=""
          style={{
            width: "90px",
            height: "65px",
            objectFit: "contain"
          }}
        />
      </div>

      <h2 className="qa-service-title">
        {service.title}
      </h2>

      <ul style={{ paddingLeft: "22px" }}>
        {service.points.map((point, idx) => (
          <li
            key={idx}
            style={{
              fontSize: "15px",
              lineHeight: "1.8",
              color: "#333"
            }}
          >
            {point}
          </li>
        ))}
      </ul>
    </div>
  ))}
</div>

{/* BOTTOM ROW - 4 CARDS */}
<div className="qa-services-bottom-grid" id="mobile-services">
  {bottomServices.map((service, i) => (
    <div
      key={i}
      className="qa-service-card-bottom"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "12px"
        }}
      >
        <img
          src={service.icon}
          alt=""
          style={{
            width: "90px",
            height: "65px",
            objectFit: "contain"
          }}
        />
      </div>

      <h2
        style={{
          fontSize: "22px",
          fontWeight: "700",
          textAlign: "center",
          marginBottom: "22px"
        }}
      >
        {service.title}
      </h2>

      <ul style={{ paddingLeft: "22px" }}>
        {service.points.map((point, idx) => (
          <li
            key={idx}
            style={{
              fontSize: "15px",
              lineHeight: "1.6",
              color: "#333"
            }}
          >
            {point}
          </li>
        ))}
      </ul>
    </div>
  ))}
</div>
        </div>

        {/* CASE STUDIES */}
        <div
          id="casestudies"
          style={{
            background: "#efefef",
            padding: "8px 50px 90px"
          }}
        >
          <h1
            style={{
              textAlign: "center",
              fontSize: "clamp(28px, 5vw, 50px)",
              marginBottom: "50px",
              fontFamily: "Exo, sans-serif",
              color: "#111"
            }}
          >
            QA Case Studies
          </h1>

          <div className="qa-casestudies-grid">
            {caseStudies.map((item, i) => (
              <div
                key={i}
                style={{
                 background: "#3148a5",
border: "3px solid #4f6fe6",
boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  borderRadius: "10px",
                  padding: "30px"
                }}
              >
                <h2
                  style={{
                    fontSize: "22px",
                    fontWeight: "700",
                    fontFamily: "Exo, sans-serif",
                color: "#20d6be",
                    lineHeight: "1.3",
                    marginBottom: "20px"
                  }}
                >
                  {item.title}
                </h2>

                <p
                  style={{
                    fontSize: "15px",
                    lineHeight: "1.8",
                    color: "#ffffff",
                    marginBottom: "18px"
                  }}
                >
                  {item.desc}
                </p>

                <p
                  style={{
                    fontSize: "15px",
                    lineHeight: "1.8",
                      color: "#ffffff",
                    marginBottom: "18px"
                  }}
                >
                  <strong>Geo:</strong> {item.geo}
                </p>

                <h3
                  style={{
                    fontSize: "18px",
                    marginBottom: "12px",
                     color: "#ffffff",
                    fontFamily: "Exo, sans-serif"
                  }}
                >
                  Tools:
                </h3>

                <ul
                  style={{
                    paddingLeft: "22px"
                  }}
                >
                  {item.tools.map((tool, idx) => (
                    <li
                      key={idx}
                      style={{
                        fontSize: "15px",
                        lineHeight: "1.8",
                        color: "#ffffff",
                      }}
                    >
                      {tool}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default QAPage;
